"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIREBASE_CONFIG = exports.SENTRY_URL = exports.CHECKR_CLIENT_ID = exports.CHECKR_REPORTS_URL = exports.CHECKR_PARTNERS_URL = exports.TEAMSNAP_URL = exports.CLIENT_ID = exports.CLASSIC_ADMIN_URL = exports.COGSWORTH_URL = exports.ACCOUNTS_URL = exports.API_KEY = exports.API_URL = exports.APP_URL = exports.IS_PROD = void 0;
var environment_1 = require("./environment");
exports.IS_PROD = environment_1.default.indexOf("prod") != -1;
exports.APP_URL = {
    local: "http://localhost:5502",
    test: "http://localhost:5502",
    staging: "https://staging.organization.teamsnap.com",
    prod: "https://organization.teamsnap.com",
}[environment_1.default];
exports.API_URL = {
    local: "http://localhost:5501",
    test: "http://localhost:5501",
    staging: "https://staging-organization-api.teamsnap.com",
    prod: "https://organization-api.teamsnap.com",
}[environment_1.default];
exports.API_KEY = {
    local: "local_key",
    test: "test_key",
    staging: "kyQPZEpHy04ucBIxwUVn7JGo48ECgYEA29zAhLFydjE49eGA6M",
    prod: "gYBBplPyC05DToVUniYw3i3UiJd8hduzuzokGXrlhG4PmYLNF3",
}[environment_1.default];
exports.ACCOUNTS_URL = {
    local: "https://accounts.teamsnap.com",
    test: "https://staging.accounts.teamsnap.com",
    staging: "https://staging.accounts.teamsnap.com",
    prod: "https://accounts.teamsnap.com",
}[environment_1.default];
exports.COGSWORTH_URL = {
    local: "http://localhost:3004/",
    test: "https://pod-sports-org.teamsnap.com:8443/",
    staging: "https://pod-sports-org.teamsnap.com:8443/",
    prod: "https://auth.teamsnap.com/",
}[environment_1.default];
exports.CLASSIC_ADMIN_URL = {
    local: "http://localhost:3001/admin",
    test: "https://pod-sports-org.teamsnap.com:8443/admin",
    staging: "https://pod-sports-org.teamsnap.com:8443/admin",
    prod: "https://go-admin.teamsnap.com/admin",
}[environment_1.default];
exports.CLIENT_ID = {
    local: "hub_uid",
    test: "hub_uid",
    staging: "hub_uid",
    prod: "67746e2da03fe8cead89a30726c15368a95eb042441f8a6a469adcfead5479ea08fca1ae0272acbb4828c65e3a52f7a280539e7dc47f68218c11b0e41cc30636",
}[environment_1.default];
exports.TEAMSNAP_URL = {
    local: "http://localhost:3001",
    test: "http://localhost:3001",
    staging: "https://pod-sports-org.teamsnap.com",
    prod: "https://go.teamsnap.com",
}[environment_1.default];
exports.CHECKR_PARTNERS_URL = "https://partners.checkr.com";
exports.CHECKR_REPORTS_URL = "https://partners.checkr.com";
exports.CHECKR_CLIENT_ID = {
    local: "47695c6987534d685d8146c0",
    staging: "47695c6987534d685d8146c0",
    prod: "da081e37b9756a2027446510",
}[environment_1.default];
exports.SENTRY_URL = "https://e90d81c7b44945b9bc253431f7f91137@o126035.ingest.sentry.io/1491155";
exports.FIREBASE_CONFIG = {
    local: {
        apiKey: "AIzaSyBX7rPA7HT4J2VaWv2EjqRtnX7rxQpchKw",
        authDomain: "live-dev-1-1.firebaseapp.com",
        databaseURL: "https://live-dev-1-1.firebaseio.com",
        projectId: "live-dev-1-1",
        storageBucket: "live-dev-1-1.appspot.com",
        messagingSenderId: "979924482870",
        appId: "1:979924482870:web:8df8e4f270a70ec04a1197",
    },
    staging: {
        apiKey: "AIzaSyBX7rPA7HT4J2VaWv2EjqRtnX7rxQpchKw",
        authDomain: "live-dev-1-1.firebaseapp.com",
        databaseURL: "https://live-dev-1-1.firebaseio.com",
        projectId: "live-dev-1-1",
        storageBucket: "live-dev-1-1.appspot.com",
        messagingSenderId: "979924482870",
        appId: "1:979924482870:web:8df8e4f270a70ec04a1197",
    },
    prod: {
        apiKey: "AIzaSyDY6y23k8gdOoyfdk_RBaGlBaUam5vuPEk",
        authDomain: "live-prod-1-1.firebaseapp.com",
        databaseURL: "https://live-prod-1-1.firebaseio.com",
        projectId: "live-prod-1-1",
        storageBucket: "live-prod-1-1.appspot.com",
        messagingSenderId: "81859586434",
        appId: "1:81859586434:web:3df00d9b086fba8b25879b",
    },
}[environment_1.default];
//# sourceMappingURL=constants.js.map